import React from 'react';
import { dashboardActions } from 'core/Dashboard';
import { getStatus } from 'shared/fixtures';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Container,
    Footer,
    IconContainer,
    InfoContainer,
    InfoRow,
    Message,
    Row,
    Session,
    TextContainer,
    Title
} from './styled';
import {
    ExpandButton,
    MaterialIcon,
    Modal,
    SelectSearch
} from 'mol-ui';
import {
    parseOTError,
    uppercaseFirst
} from 'shared/utils';
import {
    useDispatch,
    useInput,
    useSelector
} from 'hooks';

const TRACKING = 1;
const ERRORS = 2;
const ACCESSES = 3;
const INQUIRY = 4;
const TABS = [{
    label: 'Trazabilidad',
    value: TRACKING
}, {
    label: 'Errores',
    value: ERRORS
}, {
    label: 'Accesos',
    value: ACCESSES
}, {
    label: 'Encuestas',
    value: INQUIRY
}];

const CallTracking = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        callsPage: calls,
        tracking: {
            call_behaviors = [],
            call_id,
            display,
            ratings = [],
            reference,
            session,
            traceabilities = [],
            twilio_behaviors = []
        } = {}
    } = useSelector('dashboard');

    const { data: callData } = calls ? calls.getData() : { data: [] };

    const [tabsInput, selectedTab] = useInput(1);

    const callIndex = call_id && callData.length > 0 ? callData.findIndex(({ call_id: callId }) => callId === call_id) : 0;

    const getCall = index => {
        dispatch(dashboardActions.getDashboardTracking(callData[index].call_id));
    };

    const onToggle = () => {
        dispatch(dashboardActions.setDashboardTracking({ display: false }));
    };

    return (
        <Modal active={ display } width="80%" onToggle={ onToggle }>
            <Container>
                <Row>
                    <Col sm="6">
                        {
                            callIndex > 0 &&
                            <IconContainer onClick={ () => getCall(callIndex - 1) }>
                                <MaterialIcon icon="arrow_left" />
                            </IconContainer>
                        }
                        <TextContainer>
                            { t('Identificador de llamada') }: { call_id }
                        </TextContainer>
                        {
                            callIndex < callData.length - 1 &&
                            <IconContainer onClick={ () => getCall(callIndex + 1) }>
                                <MaterialIcon icon="arrow_right" />
                            </IconContainer>
                        }
                    </Col>
                    <Col sm="6">
                        <SelectSearch
                            margin="0px"
                            options={ TABS }
                            width="100%"
                            { ...tabsInput }
                        />
                    </Col>
                </Row>
                {
                    selectedTab === TRACKING &&
                    <InfoContainer>
                        <Title>{ t('Trazabilidad') }</Title>
                        {
                            traceabilities.length === 0
                                ? <Message>
                                    { t('La trazabilidad de la llamada seleccionada no se encuentra disponible.') }
                                </Message>
                                : traceabilities.map(({
                                    call_status,
                                    created_at,
                                    doctor_first_name,
                                    doctor_last_name,
                                    mode,
                                    status,
                                    type
                                }, index) => {
                                    const timestamp = moment(created_at).format('DD/MM/YYYY HH:mm:ss');
                                    if (call_status === 'Room' && ['Rejected', 'Succeded'].includes(status)) {
                                        return null;
                                    } else {
                                        return <InfoRow key={ index }>
                                            { `
                                                ${ timestamp }: ${ doctor_last_name }, ${ doctor_first_name } -
                                                (${ uppercaseFirst(mode) }) -
                                                ${ getStatus(type === 'Evolution' ? type : call_status, status, moment(created_at), true).statusLabel }
                                            ` }
                                        </InfoRow>;
                                    }
                                })
                        }
                    </InfoContainer>
                }
                {
                    selectedTab === ERRORS &&
                    <InfoContainer>
                        <Title>Errores registrados</Title>
                        {
                            twilio_behaviors.length === 0
                                ? <Message>
                                    { t('No se registraron errores para la llamada seleccionada.') }
                                </Message>
                                : twilio_behaviors.map(({
                                    created_at,
                                    error_message,
                                    user: {
                                        first_name,
                                        last_name,
                                        type
                                    }
                                }, index) => {
                                    const timestamp = moment(created_at).format('DD/MM/YYYY HH:mm:ss');
                                    return <InfoRow key={ index }>
                                        { `
                                            ${ timestamp }: ${ last_name }, ${ first_name } (${ uppercaseFirst(type) }) -
                                            ${ parseOTError(error_message) }
                                        ` }
                                    </InfoRow>;
                                })
                        }
                    </InfoContainer>
                }
                {
                    selectedTab === ACCESSES &&
                    <InfoContainer>
                        <Title>{ t('Accesos a sala virtual') }</Title>
                        {
                            call_behaviors.length === 0
                                ? <Message>
                                    { t('No se registraron accesos a la llamada seleccionada.') }
                                </Message>
                                : call_behaviors.map(({
                                    camera,
                                    created_at,
                                    device_brand,
                                    device_browser,
                                    device_browser_version,
                                    device_model,
                                    device_os,
                                    device_os_version,
                                    device_type,
                                    fe_version,
                                    microphone,
                                    user: {
                                        first_name,
                                        last_name,
                                        type
                                    },
                                    way
                                }, index) => {
                                    const timestamp = moment(created_at).format('DD/MM/YYYY HH:mm:ss');
                                    return <InfoRow key={ index }>
                                        { timestamp }: { last_name }, { first_name } ({ uppercaseFirst(type) })
                                        {
                                            !way
                                                ? `
                                                     - v${ fe_version || '0' } -
                                                    Cam: ${ uppercaseFirst(camera) }/Mic: ${ uppercaseFirst(microphone) } -
                                                    Disp: ${ device_type } ${ device_brand === 'none' ? '...' : device_brand } ${ device_model === 'none' ? '...' : device_model } -
                                                    OS: ${ device_os } ${ device_os_version }  -
                                                    Nav: ${ device_browser } ${ device_browser_version }
                                                `
                                                : way === 'out'
                                                    ? ` ${ t('Salida de la llamada') }`
                                                    : way === 'hang_up'
                                                        ? ` ${ t('Salida de la llamada desde el botón') }`
                                                        : ` ${ t('Ingreso a la llamada') }`
                                        }
                                    </InfoRow>;
                                })
                        }
                    </InfoContainer>
                }
                {
                    selectedTab === INQUIRY &&
                    <InfoContainer>
                        <Title>{ t('Encuestas') }</Title>
                        {
                            ratings.length === 0
                                ? <Message>
                                    { t('No se registraron encuestas a la llamada seleccionada.') }
                                </Message>
                                : ratings.map(({
                                    audio,
                                    created_at,
                                    comments,
                                    quality,
                                    session,
                                    user: {
                                        first_name,
                                        last_name,
                                        type
                                    },
                                    video
                                }, index) => {
                                    const timestamp = moment(created_at).format('DD/MM/YYYY HH:mm:ss');
                                    return <InfoRow key={ index }>
                                        {`
                                            ${ timestamp }: ${ last_name }, ${ first_name } (${ uppercaseFirst(type) }) -
                                            ${ t('Calidad') }: ${ quality }/5 -
                                            ${ session ? ` ${ t('Atención') }: ${ session }/5 - ` : '' }
                                            ${ t('Audio') }: ${ audio ? t('Si') : t('No') } -
                                            ${ t('Video') }: ${ video ? t('Si') : t('No') } -
                                            ${ t('Comentarios') }: ${ comments !== null ? comments : 'n/d' }
                                         `}
                                    </InfoRow>;
                                })
                        }
                    </InfoContainer>
                }
                {
                    reference &&
                    <Session>
                        { t('ID Mercadopago') }: { reference }
                    </Session>
                }
                <Session>
                    { t('Sesión') }: { session }
                </Session>
                <Footer>
                    <ExpandButton
                        caption={ t('Cerrar') }
                        size={ 100 }
                        onClick={ onToggle }
                    />
                </Footer>
            </Container>
        </Modal>
    );
};

export default CallTracking;
